import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/blog-avatar@2x.png")